'use client';

import Icon from '@/components/ui/AppIcon';

interface GalleryTabsProps {
  activeTab: 'food' | 'behind-scenes' | 'customer-stories';
  onTabChange: (tab: 'food' | 'behind-scenes' | 'customer-stories') => void;
}

export default function GalleryTabs({ activeTab, onTabChange }: GalleryTabsProps) {
  const tabs = [
    { id: 'food' as const, label: 'Food Gallery', icon: 'CameraIcon' },
    { id: 'behind-scenes' as const, label: 'Behind the Scenes', icon: 'FilmIcon' },
    { id: 'customer-stories' as const, label: 'Customer Stories', icon: 'HeartIcon' },
  ];

  return (
    <div data-component-id="src/app/gallery/components/GalleryTabs.tsx:18:4" data-component-path="src/app/gallery/components/GalleryTabs.tsx" data-component-line="18" data-component-file="GalleryTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20sm%3Aflex-row%20items-center%20justify-center%20gap-4%20border-b%20border-border%20pb-6%22%7D" className="flex flex-col sm:flex-row items-center justify-center gap-4 border-b border-border pb-6">
      {tabs.map((tab) => (
        <button data-component-id="src/app/gallery/components/GalleryTabs.tsx:20:8" data-component-path="src/app/gallery/components/GalleryTabs.tsx" data-component-line="20" data-component-file="GalleryTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-cta transition-smooth ${
            activeTab === tab.id
              ? 'bg-primary text-primary-foreground shadow-brand'
              : 'bg-card text-text-secondary hover:bg-muted hover:text-primary'
          }`}
        >
          <Icon data-component-id="src/app/gallery/components/GalleryTabs.tsx:29:10" data-component-path="src/app/gallery/components/GalleryTabs.tsx" data-component-line="29" data-component-file="GalleryTabs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={tab.icon as any} size={20} />
          <span data-component-id="src/app/gallery/components/GalleryTabs.tsx:30:10" data-component-path="src/app/gallery/components/GalleryTabs.tsx" data-component-line="30" data-component-file="GalleryTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}